const LOCKED_SIZE = "__LOCKED__"

const AptUnitMiniMap = ({ unitMap, palette }) => {
  const unitNos = Object.keys(unitMap).map(Number)

  if (unitNos.length === 0) {
    return (
      <div className="h-32 flex items-center justify-center text-sm text-gray-400">배치도 없음</div>
    )
  }

  const floors = [...new Set(unitNos.map((v) => Math.floor(v / 100)))].sort((a, b) => b - a)

  const hos = [...new Set(unitNos.map((v) => v % 100))].sort((a, b) => a - b)

  const CELL_WIDTH = 16
  const CELL_HEIGHT = 10

  return (
    <svg width={hos.length * CELL_WIDTH} height={floors.length * CELL_HEIGHT} className="mx-auto">
      {floors.map((floor, yIdx) =>
        hos.map((ho, xIdx) => {
          const unitNo = floor * 100 + ho
          const size = unitMap[unitNo]

          // 1. 아예 없는 호실은 그리지 않음
          if (size === undefined) {
            return null
          }

          const x = xIdx * CELL_WIDTH
          const y = yIdx * CELL_HEIGHT

          return (
            <g key={unitNo}>
              <rect
                x={x}
                y={y}
                width={CELL_WIDTH - 1}
                height={CELL_HEIGHT - 1}
                fill={size === LOCKED_SIZE ? "#fff" : palette[size]}
                stroke="#d1d5db"
                strokeWidth={0.5}
              />

              {/* 2. LOCKED는 X 표시 */}
              {size === LOCKED_SIZE && (
                <>
                  <line
                    x1={x + 2}
                    y1={y + 2}
                    x2={x + CELL_WIDTH - 3}
                    y2={y + CELL_HEIGHT - 3}
                    stroke="#d1d5db"
                    strokeWidth={1}
                  />

                  <line
                    x1={x + CELL_WIDTH - 3}
                    y1={y + 2}
                    x2={x + 2}
                    y2={y + CELL_HEIGHT - 3}
                    stroke="#d1d5db"
                    strokeWidth={1}
                  />
                </>
              )}
            </g>
          )
        })
      )}
    </svg>
  )
}

export default AptUnitMiniMap
